import Gallery from './Gallery';
import Badges from '@jetshop/ui/ProductList/Badges';
import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';
import { AddFavourite } from '../../ProductList/AddFavourite';

const Wrapper = styled('div')`
  position: relative;
  display: flex;
  flex-direction: column;

  .image-gallery-slide-wrapper {
    ${theme.below.lg} {
      width: 100% !important;
    }
  }
  .image-gallery-thumbnails-wrapper {
    ${theme.below.lg} {
      display: none !important;
    }
  }

  ${theme.below.lg} {
    padding: 0;
  }
  ${theme.below.md} {
    margin: auto;
    width: 90%;
    .image-gallery-thumbnails-container {
      display: none;
    }
  }
  .badges-wrapper {
    & > div > div {
      top: 10px;
      padding: 0 10px;
      div {
        margin-bottom: 5px;
      }
    }
    > div > div > div {
      font-weight: bold;
      font-size: 0.55rem;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      width: auto;
      height: auto;
      color: black;
      background: none;

      &.sale-tagg {
        background: none;
      }

      &.member-tagg {
        background: none;
      }

      &.best-price-tagg {
        background: none;
      }

      &.new-tagg {
        background: none;
      }
    }
  }
`;

export default function ImageContainer({
  images,
  product,
  badges,
  video,
  ...rest
}) {
  const galleryRef = React.createRef();
  return (
    <Wrapper {...rest}>
      <Gallery
        aspect="2:3"
        images={images}
        galleryRef={galleryRef}
        video={video ? video : false}
      >
        <div className="badges-wrapper">
          <Badges badges={badges} />
        </div>

        <AddFavourite
          product={product}
          style={{
            bottom: '55px',
            right: '8px',
            width: '40px',
            height: '40px'
          }}
        />
      </Gallery>
    </Wrapper>
  );
}
